import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home'
import Login from '@/views/Login'
import Shelvery from '@/views/Shelvery'
import ShelveryService from '@/views/ShelveryService'
import Backups from '@/views/Backups'
import Monitoring from '@/views/Monitoring'
import BackupService from '@/views/BackupService'
import Base2Bot from '@/views/Base2Bot'
import Cards from '@/views/Cards'
import Work from '@/views/Work'
import Alerts from '@/views/Alerts'
import IncomingCalls from '@/views/IncomingCalls'
import Deployment from '@/views/Deployment'
import Tools from '@/views/Tools'
import OpsTools from '@/views/OpsTools'
import ZendeskSummary from '@/views/ZendeskSummary'
import CiinaboxDeployments from '@/views/CiinaboxDeployments'
import Resources from '@/views/Resources'
import Costs from '@/views/Costs'
import Assets from '@/views/Assets'
import InsightsTester from '../views/InsightsTester.vue'
import ContractModify from '@/views/ContractModify'
import ContractNew from '@/views/ContractNew'
import ContractDelete from '@/views/ContractDelete'
import GroupModify from '@/views/GroupModify'
import GroupNew from '@/views/GroupNew'
import GroupDelete from '@/views/GroupDelete'
import AIPage from '@/views/AIPage'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresAuth: false,
        admin: false
      }
    },
    {
      path: '/:id/shelvery',
      name: 'Shelvery',
      component: Shelvery,
      props: true,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: '/:id/shelvery/:service',
      name: 'ShelveryService',
      component: ShelveryService,
      props: true,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: '/:id/backups',
      name: 'Backups',
      component: Backups,
      props: true,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: '/:id/AIPage',
      name: 'AIPage',
      component: AIPage,
      props: true,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: '/:id/monitoring',
      name: 'Monitoring',
      component: Monitoring,
      props: true,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: '/:id/backups/:service',
      name: 'BackupService',
      component: BackupService,
      props: true,
      meta: {
        requiresAuth: true,
        admin: false
      }
    },
    {
      path: '/:id/base2bot',
      name: 'Base2Bot',
      component: Base2Bot,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/cards',
      name: 'Cards',
      component: Cards,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/work',
      name: 'Work',
      component: Work,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/alerts',
      name: 'Alerts',
      component: Alerts,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/calls',
      name: 'IncomingCalls',
      component: IncomingCalls,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/deployments',
      name: 'Deployments',
      component: Deployment,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/base2tools',
      name: 'Tools',
      component: Tools,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/OpsTools',
      name: 'OpsTools',
      component: OpsTools,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/ZendeskSummary',
      name: 'ZendeskSummary',
      component: ZendeskSummary,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/CiinaboxDeployments',
      name: 'CiinaboxDeployments',
      component: CiinaboxDeployments,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/Resources/:resource',
      name: 'Resources',
      component: Resources,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/Costs',
      name: 'Costs',
      component: Costs,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/Assets/',
      name: 'Assets',
      component: Assets,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/:id/InsightsTester/',
      name: 'InsightsTester',
      component: InsightsTester,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/contract/:id/modify',
      name: 'ContractModify',
      component: ContractModify,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/contract/new',
      name: 'ContractNew',
      component: ContractNew,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/contract/:id/delete',
      name: 'ContractDelete',
      component: ContractDelete,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/group/new',
      name: 'GroupNew',
      component: GroupNew,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/group/:id/modify',
      name: 'GroupModify',
      component: GroupModify,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    },
    {
      path: '/group/:id/delete',
      name: 'GroupDelete',
      component: GroupDelete,
      props: true,
      meta: {
        requiresAuth: true,
        admin: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && !store.getters.authenticated) next({ name: 'Login' })
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js